import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { ReactComponent as Chevron } from "assets/svg/chevronRight.svg";

const Wrapper = styled.button`
  border-radius: ${({ theme }) => theme.radius.large}px;
  border: 1px solid ${({ theme }) => theme.palette.primary};
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.spacer}px;
  padding-right: 0;
  background-color: ${({ theme }) => theme.palette.white};
  ${({ theme }) => theme.resFontSize.medium};
  width: 100%;

  > .contentWrapper {
    flex-grow: 1;
    border-right: 1px solid ${({ theme }) => theme.palette.blue.lighter};
    padding: 0 ${({ theme }) => theme.spacer * 2}px;
    height: 100%;
    display: flex;
    align-items: center;
  }

  svg.chevron {
    flex-shrink: 0;
    height: 1.2rem;
    margin: 0 ${({ theme }) => theme.spacer * 2}px;
  }

  @media print {
    display: none;
  }
`;

const OutlinedLink = ({ className, children, onClick }) => {
  const classes = ["OutlinedLink"];
  if (className) classes.push(className);

  return (
    <Wrapper className={classes.join(" ")} onClick={onClick}>
      <div className="contentWrapper">{children}</div>
      <Chevron className="chevron" />
    </Wrapper>
  );
};

OutlinedLink.displayName = "OutlinedLink";

OutlinedLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.node
};

OutlinedLink.defaultProps = {
  className: null,
  onClick: null
};

export default OutlinedLink;
